import React from 'react'
import { styled } from '@mui/material/styles'
import PropTypes from 'prop-types'
import { Chip as MuiChip, Tooltip } from '@mui/material'
import ThemeConfig from './../../theme/ThemeConfig'
import { fade } from '../../helpers/colorUtil'

const PREFIX = 'Chip'

const classes = {
  root: `${PREFIX}-root`,
  clickable: `${PREFIX}-clickable`,
  deletable: `${PREFIX}-deletable`,
  deleteIcon: `${PREFIX}-deleteIcon`,
}

const StyledMuiChip = styled(MuiChip)(color => {
  return {
    [`& .${classes.root}`]: props => ({
      margin: ThemeConfig.spacing(0.25),
      color: ThemeConfig.palette[props.color].contrastText,
      backgroundColor: ThemeConfig.palette[props.color].main,
    }),
    [`& .${classes.clickable}`]: props => ({
      '&:hover, &:focus': {
        backgroundColor: ThemeConfig.palette[props.color].dark,
      },
      '&:active': {
        backgroundColor: ThemeConfig.palette[props.color].dark,
      },
    }),
    [`& .${classes.deletable}`]: props => ({
      '&:focus': {
        backgroundColor: ThemeConfig.palette[props.color].dark,
      },
    }),
    [`& .${classes.deleteIcon}`]: props => ({
      color: fade(ThemeConfig.palette[props.color].contrastText, 70),
      '&:hover, &:active': {
        color: fade(ThemeConfig.palette[props.color].contrastText, 90),
      },
    }),
  }
})

// Display ellipsis and a tooltip if text overflows.
const Label = props => {
  const { text, width } = props
  const style = {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  }
  if (width) {
    style.width = Number(width)
  }
  return width ? (
    <Tooltip title={text}>
      <div style={style}>{text}</div>
    </Tooltip>
  ) : (
    <div style={style}>{text}</div>
  )
}

const Chip = ({ label, width = '', color = 'defaultGrey', ...other }) => {
  const verifiedColor = color === 'default' ? 'defaultGrey' : color

  return (
    <StyledMuiChip
      label={<Label text={label} width={width} />}
      color={verifiedColor}
      classes={{
        ...classes,
      }}
      {...other}
    />
  )
}

Chip.propTypes = {
  label: PropTypes.string.isRequired,
  color: PropTypes.oneOf([
    'default',
    'primary',
    'secondary',
    'warning',
    'error',
  ]),
  width: PropTypes.number,
}

Chip.muiName = MuiChip.muiName

export default Chip
